import * as tslib_1 from "tslib";
import { Event } from "./Event";
import { EventDispatcher as AwayEventDispatcher } from "@awayjs/core";
/**
     * [broadcast event] Dispatched when the Flash Player or AIR application operating
     * loses system focus and is becoming inactive.
     * @eventType	flash.events.Event.DEACTIVATE
    [Event(name="deactivate", type="flash.events.Event")]

     * [broadcast event] Dispatched when the Flash Player or AIR application gains
     * operating system focus and becomes active.
     * @eventType	flash.events.Event.ACTIVATE
    [Event(name="activate", type="flash.events.Event")]
 */
var EventDispatcher = (function (_super) {
    tslib_1.__extends(EventDispatcher, _super);
    function EventDispatcher(target) {
        if (target === void 0) { target = null; }
        var _this = _super.call(this, target) || this;
        _this.eventMapping = {};
        _this.eventMappingDummys = {};
        _this.eventMappingExtern = {};
        _this.eventMappingInvert = {}; //only needed in some cases, when we translate back from awayjs-type to flash-type
        _this._activateCallbackDelegate = function (event) { return _this.activateCallback(event); };
        _this.eventMapping[Event.ACTIVATE] = {
            adaptedType: "",
            addListener: _this.initActivateListener,
            removeListener: _this.removeActivateListener,
            callback: _this._activateCallbackDelegate
        };
        _this._deactivateCallbackDelegate = function (event) { return _this.deactivateCallback(event); };
        _this.eventMapping[Event.DEACTIVATE] = {
            adaptedType: "",
            addListener: _this.initDeactivateListener,
            removeListener: _this.removeDeactivateListener,
            callback: _this._deactivateCallbackDelegate
        };
        return _this;
    }
    // ---------- event mapping functions Event.ACTIVATE
    EventDispatcher.prototype.initActivateListener = function (type, callback) {
        window.onfocus = callback;
    };
    EventDispatcher.prototype.removeActivateListener = function (type, callback) {
        window.onfocus = null;
    };
    EventDispatcher.prototype.activateCallback = function (event) {
        if (event === void 0) { event = null; }
        this.dispatchEvent(new Event(Event.ACTIVATE));
    };
    // ---------- event mapping functions Event.DEACTIVATE
    EventDispatcher.prototype.initDeactivateListener = function (type, callback) {
        window.onblur = callback;
    };
    EventDispatcher.prototype.removeDeactivateListener = function (type, callback) {
        window.onblur = null;
    };
    EventDispatcher.prototype.deactivateCallback = function (event) {
        if (event === void 0) { event = null; }
        this.dispatchEvent(new Event(Event.DEACTIVATE));
    };
    /*overwrite*/
    EventDispatcher.prototype.addEventListener = function (type, listener, useCapture, priority, useWeakReference) {
        if (useCapture === void 0) { useCapture = false; }
        if (priority === void 0) { priority = 0; }
        if (useWeakReference === void 0) { useWeakReference = false; }
        if (this.eventMappingExtern.hasOwnProperty(type)) {
            // this is a external eventMapping
            // this means that we do not need to create any mapping, and will manually dispatch the event
            // we still need to register it on superclass, so it will work if we dispatch it manually
            _super.prototype.addEventListener.call(this, type, listener);
            return;
        }
        if (this.eventMappingDummys.hasOwnProperty(type)) {
            // this is a dummy eventMapping
            // this means that this is a event-type, that is not yet supported
            // we do not need to register it on superclass
            // for now we output a warning
            //console.log("Warning - EventDispatcher:  trying to listen for unsupported event: : "+this.eventMappingDummys[type]);
            return;
        }
        if (this.eventMapping.hasOwnProperty(type)) {
            // a mapping exists for this event
            //making sure standart behaviour still works (listener is tracked in list)
            _super.prototype.addEventListener.call(this, type, listener);
            // call the provided "addListener" function
            this.eventMapping[type].addListener.call(this, this.eventMapping[type].adaptedType, this.eventMapping[type].callback);
            return;
        }
        // if we make it here, the event is not handled by this dispatcher
        // lets output a Warning for now.
        //console.log("EventDispatcher: trying to listen for unknown event: '"+type+"'")
    };
    /**
     * Remove an event listener
     * @method removeEventListener
     * @param {String} type of event to remove a listener for
     * @param {Function} listener function
     */
    EventDispatcher.prototype.removeEventListener = function (type, listener) {
        _super.prototype.removeEventListener.call(this, type, listener);
        if (this.eventMapping.hasOwnProperty(type)) {
            // a mapping exists
            this.eventMapping[type].removeListener.call(this, this.eventMapping[type].adaptedType, this.eventMapping[type].callback);
        }
    };
    return EventDispatcher;
}(AwayEventDispatcher));
export { EventDispatcher };
